<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app floating class="elevation-3">
      <!-- Premium Header Section -->
      <v-sheet color="white" class="px-4 pt-5 pb-3" style="width: 100%;">
        <!-- Logo Container -->
        <div class="mb-4">
          <v-img 
            src="/otb-logo.png" 
            height="45" 
            max-width="150" 
            contain 
            position="left center"
          ></v-img>
        </div>

        <!-- User Profile Card -->
        <div class="mt-4 pa-3 rounded-lg" style="background-color: #fafafa; border: 1px solid #f0f0f0; width: 100%;">
          <div style="min-width: 0; width: 100%;">
            <div class="subtitle-2 font-weight-bold text-truncate grey--text text--darken-4 mb-1" :title="user.email" style="line-height: 1.1;">
              {{ user.email }}
            </div>
            <v-chip
              x-small
              color="primary"
              class="white--text font-weight-bold"
              style="height: 16px; font-size: 0.6rem; letter-spacing: 0.3px;"
            >
              {{ user.role.name }}
            </v-chip>
          </div>
        </div>
      </v-sheet>

      <v-divider></v-divider>

      <!-- Navigation Links -->
      <v-list nav dense class="px-3 mt-3">
        <v-list-item
          v-for="[icon, text, link] in links"
          :key="icon"
          link
          :to="link"
          exact
          color="primary"
          class="mb-2 nav-item transition-swing"
          active-class="primary--text v-list-item--active"
        >
          <v-list-item-icon class="mr-4">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{ text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-4">
          <v-divider class="mb-4"></v-divider>
          <v-list-item @click="logout" link class="nav-item hover-red transition-swing rounded-lg">
            <v-list-item-icon class="mr-4">
              <v-icon color="error">mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="error--text font-weight-medium">Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main class="grey lighten-4">
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    cards: ["Today", "Yesterday"],
    drawer: null,
  }),
  computed: {
    ...mapGetters("auth", [
      "user",
      "isSuperAdmin",
      "isSchoolAdmin",
      "isTeacher",
    ]),
    links() {
      if (this.isTeacher) {
        return [
          ["mdi-school", "Class", "/class"],
          ["mdi-chart-bar", "Stats", "/stats"],
        ];
      }

      if (this.isSchoolAdmin) {
        return [
          ["mdi-school", "School", "/school"],
          ["mdi-checkbox-multiple-marked", "Classes", "/skills"],
          ["mdi-view-dashboard", "Teachers", "/teachers"],
        ];
      }

      const links = [
        ["mdi-school", "Schools", "/schools"],
        ["mdi-checkbox-multiple-marked", "Skills", "/skills"],
        ["mdi-newspaper-variant-outline", "News", "/news"],
      ];

      if (this.isSuperAdmin) {
        links.push(["mdi-view-dashboard", "Dashboard", "/dashboard"]);
      }

      return links;
    },
  },
  methods: {
    ...mapActions({
      logoutAction: "auth/logout",
    }),
    async logout() {
      await this.logoutAction();

      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.transition-swing {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.nav-item {
  border-radius: 8px !important;
}

.nav-item:hover:not(.v-list-item--active) {
  background-color: rgba(244, 67, 54, 0.04) !important;
  transform: translateX(4px);
}

.v-list-item--active {
  background-color: rgba(244, 67, 54, 0.08) !important;
  border-left: 4px solid #F44336;
}

.hover-red:hover {
  background-color: rgba(244, 67, 54, 0.08) !important;
  transform: translateX(4px);
}
</style>